module.exports = __webpack_public_path__ + "static/media/home-stage-x1.5f1aee82.jpg";